import ConfirmPopover from '@/components/common/ConfirmPopover';
import DataTypeSelect from '@/components/common/DataTypeSelect';
import ListArrows from '@/components/common/ListArrows';
import TextFieldWrapper from '@/components/common/TextFieldWrapper';
import { ReturnType } from '@/types/subroutine';
import ClearIcon from '@mui/icons-material/Clear';
import { FormControl, Stack } from '@mui/material';
import { FC } from 'react';

type TypeSelectProps = {
  value: ReturnType;
  data: ReturnType[];
  index: number;
  type: string;
  onArrowClick: (data: ReturnType[], arrowType: string) => void;
  onChange: (value: ReturnType) => void;
  onDelete: () => void;
};

const TypeSelect: FC<TypeSelectProps> = (props) => {
  return (
    <Stack direction='row' alignItems='center' justifyContent='space-between' width='100%'>
      <TextFieldWrapper
        size='small'
        value={props.value?.label}
        placeholder='label'
        onChange={(e) => props.onChange({ ...props.value, label: e.currentTarget.value })}
        sx={{ minWidth: 100, maxWidth: '50%', mr: 2, flex: 1 }}
      />
      <FormControl size='small' sx={{ flexShrink: 1.5, flexDirection: 'row' }}>
        <DataTypeSelect
          value={props.value?.type}
          typelist={props.type}
          onChange={(type) => props.onChange({ ...props.value, type: type })}
        />
        <ListArrows data={props.data} index={props.index} onChange={props.onArrowClick} />
        <ConfirmPopover
          text={
            <>
              Remove <code>{props.value?.label}</code>?
            </>
          }
          icon={<ClearIcon />}
          onConfirm={props.onDelete}
          skipConfirm={!props.value?.type && !props.value?.label}
        />
      </FormControl>
    </Stack>
  );
};

export default TypeSelect;
